module PortalLibs.Client.Components.SearchboxNew


open Fulma
open Fable.FontAwesome
open Fable.Core.JsInterop
open Fable.React
open Fable.React.Props
open Elmish
open Feliz
open PortalLibs.Client.Util
open PortalLibs.Shared


let SearchboxNew =
  React.memo (
    "SearchboxNew",
    (fun (props: {| Key: string
                    Value: string option
                    IsLoading: bool
                    IconVisible: bool
                    ShouldFocus: bool
                    ValueChanged: string option -> unit |}) ->    
      DebouncedView.DebouncedView
        {| Key = $"SearchboxDebouncedView-%s{props.Key}"
           Value = props.Value
           ValueChanged = props.ValueChanged
           Intercept = None
           View =
             (fun valueOpt valueChanged ->
               let leftIconPadding = if props.IconVisible then 23 else 0
               let hiddenInputRef: IRefValue<Browser.Types.HTMLElement option> = createRef None

               React.useEffect (
                (fun () -> 
                    if props.ShouldFocus then
                      hiddenInputRef.current
                      |> Option.iter (fun r -> r.focus())),
                Array.singleton<obj> props.ShouldFocus)
               
               Control.div [ Control.HasIconLeft
                             Control.HasIconRight ] [
                 yield
                   Html.input [
                     prop.className "input"
                     prop.type'.text
                     prop.ref hiddenInputRef
                     prop.onChange (fun (e: Browser.Types.Event) -> !!e.target?value |> Option.noneIfEmptyStr |> valueChanged)
                     prop.value (valueOpt |> Option.emptyStrIfNone)
                     prop.style [ style.paddingLeft
                                    (if props.IsLoading && props.IconVisible then
                                      leftIconPadding + 23 + 10
                                     else leftIconPadding + 10
                                     |> length.px)
                                  ]
                     prop.maxLength 300
                   ]    

                 if props.IconVisible then
                   yield
                     Icon.icon [ Icon.Size IsSmall; Icon.IsLeft ] [
                       Fa.i [ Fa.Solid.Search ] []
                     ]
                 if props.IsLoading && props.IconVisible then
                   yield
                     Icon.icon [ Icon.Size IsSmall
                                 Icon.IsLeft
                                 Icon.Props [
                                   Style [
                                     MarginLeft $"%i{leftIconPadding}px"
                                   ]
                                 ]
                                 ] [
                       Fa.i [ Fa.Solid.Spinner; Fa.Pulse ] []
                     ]
                 if valueOpt |> Option.noneIfEmptyStrOpt <> None then
                   yield
                     Icon.icon [ Icon.Size IsSmall
                                 Icon.IsRight
                                 Icon.Props [
                                   Style [ PointerEvents "all" ]
                                 ]
                                  ] [
                       Html.a [
                         prop.onClick (fun _ -> None |> valueChanged)
                         prop.style [ style.color "gray" ]
                         prop.children [
                           Fa.i [ Fa.Solid.Times ] []
                         ]
                       ]
                     ]
               ]) |}),
    (fun (props: {| Key: string
                    Value: string option
                    IsLoading: bool
                    IconVisible: bool
                    ShouldFocus: bool
                    ValueChanged: string option -> unit |}) -> props.Key),
    areEqual = Helpers.equalsButFunctions
  )

let viewWithHeader header props =
  field header [ SearchboxNew props ]
